import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAllPersonalCollections } from '../../../api';

const CollectionsList = () => {
    const navigate = useNavigate();
    const [collections, setCollections] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            navigate('/');
            return;
        }

        fetchCollections();
    }, [navigate]);

    const fetchCollections = async () => {
        try {
            setLoading(true);
            setError('');
            const data = await getAllPersonalCollections();
            setCollections(data || []);
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to fetch collections.');
            console.error('Error fetching collections:', err);
        } finally {
            setLoading(false);
        }
    };

    const token = localStorage.getItem('token');
    if (!token) {
        return null;
    }

    return (
        <div style={{
            minHeight: '100vh',
            background: '#ccdff5',
            padding: '40px 20px'
        }}>
            <div style={{
                maxWidth: '1400px',
                margin: '0 auto',
                background: '#F6F6F6',
                borderRadius: '20px',
                padding: '40px',
                boxShadow: '0 4px 24px rgba(44, 62, 80, 0.08)'
            }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '30px'
                }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '40px' }}>
                        <div>
                            <h1 style={{ fontSize: '2.5rem', fontWeight: '800', margin: '0 0 10px 0', color: '#1e293b' }}>My Collections</h1>
                            <p style={{ fontSize: '1.1rem', color: '#64748b', margin: 0 }}>Manage your personal flashcard sets</p>
                        </div>
                        <button 
                            onClick={() => navigate('/create-collection')}
                            style={{
                                background: '#1e293b',
                                color: 'white',
                                padding: '12px 24px',
                                borderRadius: '12px',
                                border: 'none',
                                fontSize: '1rem',
                                fontWeight: '600',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                transition: 'all 0.2s ease',
                                boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
                            }}
                            onMouseEnter={(e) => e.target.style.background = '#334155'}
                            onMouseLeave={(e) => e.target.style.background = '#1e293b'}
                        >
                            <span style={{ fontSize: '1.2rem' }}>+</span> Create Collection
                        </button>
                    </div>
                </div>

                {error && (
                    <div style={{
                        color: '#dc2626',
                        marginBottom: '20px',
                        padding: '12px',
                        background: '#fee2e2',
                        borderRadius: '8px',
                        fontSize: '14px'
                    }}>
                        {error}
                    </div>
                )}

                {loading ? (
                    <div style={{
                        textAlign: 'center',
                        padding: '60px 20px',
                        color: '#707F81',
                        fontSize: '1.1rem'
                    }}>
                        Loading collections...
                    </div>
                ) : collections.length === 0 ? (
                    <div style={{
                        textAlign: 'center',
                        padding: '60px 20px',
                        color: '#707F81',
                        fontSize: '1.1rem'
                    }}>
                        No collections found.
                    </div>
                ) : (
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
                        gap: '24px'
                    }}>
                        {collections.map((collection, index) => (
                            <div
                                key={collection.id || collection._id || index}
                                onClick={() => navigate(`/collection-details/${collection.id || collection._id}`)}
                                style={{
                                    background: '#e5eff8',
                                    borderRadius: '16px',
                                    padding: '24px',
                                    border: '1px solid #cfd8dc',
                                    boxShadow: '0 2px 12px rgba(44, 62, 80, 0.08)',
                                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                    cursor: 'pointer'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-5px)';
                                    e.currentTarget.style.boxShadow = '0 8px 30px rgba(0, 0, 0, 0.1)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 2px 12px rgba(44, 62, 80, 0.08)';
                                }}
                            >
                                <h3 style={{
                                    color: '#3c5a5d',
                                    marginBottom: '12px',
                                    fontSize: '1.5rem',
                                    fontWeight: '600',
                                }}>
                                    {collection.collection_name || 'Untitled Collection'}
                                </h3>
                                
                                {collection.collection_description && (
                                    <p style={{
                                        color: '#546e7a',
                                        fontSize: '0.95rem',
                                        lineHeight: '1.5',
                                        marginBottom: '16px',
                                        display: '-webkit-box',
                                        WebkitLineClamp: 3,
                                        WebkitBoxOrient: 'vertical',
                                        overflow: 'hidden'
                                    }}>
                                        {collection.collection_description}
                                    </p>
                                )}

                                <div style={{
                                    display: 'flex',
                                    gap: '8px',
                                    flexWrap: 'wrap',
                                    marginTop: 'auto'
                                }}>
                                    {collection.cards && (
                                        <span style={{
                                            background: '#dbeafe',
                                            color: '#1e40af',
                                            padding: '4px 10px',
                                            borderRadius: '16px',
                                            fontSize: '0.85rem',
                                            fontWeight: '600',
                                        }}>
                                            {collection.cards.length} Cards
                                        </span>
                                    )}
                                    {collection.level && (
                                        <span style={{
                                            background: '#f3e8ff',
                                            color: '#6b21a8',
                                            padding: '4px 10px',
                                            borderRadius: '16px',
                                            fontSize: '0.85rem',
                                            fontWeight: '600',
                                            textTransform: 'capitalize'
                                        }}>
                                            {collection.level}
                                        </span>
                                    )}
                                    <div style={{ display: 'flex', gap: '2px', alignItems: 'center' }}>
                                        {collection.language && (
                                            <span style={{
                                                background: '#e0e7ff',
                                                color: '#3730a3',
                                                padding: '4px 8px',
                                                borderRadius: '16px 0 0 16px',
                                                fontSize: '0.8rem',
                                                fontWeight: '700',
                                                textTransform: 'uppercase'
                                            }}>
                                                {collection.language}
                                            </span>
                                        )}
                                        {collection.translation_language && (
                                            <span style={{
                                                background: '#f1f5f9',
                                                color: '#475569',
                                                padding: '4px 8px',
                                                borderRadius: '0 16px 16px 0',
                                                fontSize: '0.8rem',
                                                fontWeight: '700',
                                                textTransform: 'uppercase',
                                                borderLeft: '1px solid #cbd5e1'
                                            }}>
                                                {collection.translation_language}
                                            </span>
                                        )}
                                    </div>
                                    {collection.is_learned && (
                                        <span style={{
                                            background: '#fef08a',
                                            color: '#854d0e',
                                            padding: '4px 10px',
                                            borderRadius: '16px',
                                            fontSize: '0.85rem',
                                            fontWeight: '700',
                                        }}>
                                            ✓
                                        </span>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default CollectionsList;
